// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from 'components/Auth'
import dbImage from 'images/path-database_whiteIcon.png'

const PathDatabase = () => {
  const { groups } = useContext(AuthContext)

  return (
    groups.includes('Path_Database')
      ? (
        <Link
          className={'home-cta'}
          id={'home-nav-path-database'}
          to={'/path-database'}>
          <img
            alt={'PATH DATABASE'}
            className={'home-cta-icon'}
            src={dbImage} />
          {'PATH DATABASE'}
        </Link>
      ) : (
        <div className={'home-cta'}>
          <img
            alt={'PATH DATABASE'}
            className={'home-cta-icon'}
            src={dbImage} />
          {'PATH DATABASE'}
          <div className={'home-cta-disabled-message'}>
            {'This section is reserved for our frequency protection customers. Please contact '}
            <a
              href={'mailto:customersupport@comsearch.com'}
              rel={'noopener noreferrer'}
              target={'_blank'}>
              {'customersupport@comsearch.com'}
            </a>
            {' to learn more about the service.'}
          </div>
        </div>
      )
  )
}

export default PathDatabase
